<template>
<div>
  <form @submit.prevent="submit">
    <b-row>

<!-- shipment = models.ForeignKey(Shipment, on_delete=models.CASCADE, verbose_name="Embarque")
    vgm = models.DecimalField('vgm', max_digits=5, decimal_places=2)
    sag_sheet = models.CharField('Planilla SAG', max_length=100)
    sag_worker = models.ForeignKey(Worker, verbose_name="Contraparte SAG", on_delete=models.CASCADE) -->
   <b-col sm="12">
         <b-form-group label="Instructivo de Embarque" >
           <v-select
              :options="boardinginstructions"
              v-model="$v.waybillDataExportacion.shipment.$model"
              :state="$v.waybillDataExportacion.shipment.$dirty ? !$v.waybillDataExportacion.shipment.$error : null"
              label="text"
              :reduce="text => text.value"
              class="style-chooser ">
            </v-select>


         </b-form-group>

           <b-form-group label="Tara total del camion">
           <b-form-input
            type="text"
            :state="$v.waybillDataExportacion.vgm.$dirty ? !$v.waybillDataExportacion.vgm.$error : null"
            v-model="$v.waybillDataExportacion.vgm.$model"
            v-on:keyup = "inputSoloNumeroDecimal"
            placeholder="">
            </b-form-input>
            </b-form-group>



            <b-form-group label="Planilla SAG">
           <b-form-input
            type="text"
            :state="$v.waybillDataExportacion.sag_sheet.$dirty ? !$v.waybillDataExportacion.sag_sheet.$error : null"
            v-model="$v.waybillDataExportacion.sag_sheet.$model"
            placeholder="">
            </b-form-input>
            </b-form-group>

             <b-form-group label="Contraparte SAG">
            <b-form-select
            :state="$v.waybillDataExportacion.sag_worker.$dirty ? !$v.waybillDataExportacion.sag_worker.$error : null"
            v-model="$v.waybillDataExportacion.sag_worker.$model"
            :options="workers"></b-form-select>
            </b-form-group>



 
      </b-col> 
 


      
    </b-row>
  </form>
  </div>
</template>

<script>

  import {required, numeric, decimal} from 'vuelidate/lib/validators'
import { log } from 'util';
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css';

  export default {
    name: "formGuiaDespachoExportacion",
    props: [
    'waybillDataExportacion',
    'loadDateTable',
    'readOnly',
    ],
      components: {
        vSelect
  },
    data() {
      return {
          workers:"",
           boardinginstructions:[],
      }
    },
    validations: {
      waybillDataExportacion: {
        shipment: {required},
        vgm: {required , decimal },
        sag_sheet: {required, numeric},
        sag_worker: {required},
      }
    },
    mounted () {
     this.loadDataForm();
    },
      watch: {
    'waybillDataExportacion.shipment': function(val) {

     this.$emit("loadDateTable", val);

    }

  },
    methods: {
      
       getPallets(a){

      console.log("aqui");

      },
      saveForm(){

       this.$v.$touch();
      if (this.$v.$invalid) {
        return 0;
      } else {
        return 1;
      }

      },
      loadDataForm(){
      
          this.$axios.get ('/api/comex/shipment/getShipment/')
          .then(res => {

            let objInfo= res.data;


            for(let i in objInfo)
            {
               this.waybillDataExportacion.shipment_type = objInfo[i].shipment_type.id;
               this.boardinginstructions.push({value: objInfo[i].id, text: objInfo[i].boarding_number+"-"+objInfo[i].shipment_type.name});
            }

          })
        .catch(error => {
          console.log(error.response)
        });


        this.$axios.get ('/production/get_client_plants/')
          .then(res => {
            this.workers = res.data.workers;
            this.workers.unshift({value: '', text: 'Seleccione'})
          })
        .catch(error => {
          console.log(error.response)
        });



      },
      submit() {
      },
       inputSoloNumeroDecimal(event) {

     event.target.value = event.target.value.replace(/[^0-9.]/, '');

    }
    },
    beforeMount() {
      
    },
   
  }

</script>

<style scoped>

</style>
